import request from '@/util/request'


export const navList = (data) => request.post('/apis/api/index/cate', data);  //导航接口

export const productCate = (data) => request.post('/apis/api/index/product_cate', data);  //查询产品左侧分类

export const productCates = (data) => request.post('/apis/api/index/product_cates', data);  //查询产品左侧分类

export const productAuth = (data) => request.post('/apis/api/index/product_cert', data);  //查询产品左侧认证

export const productList = (data) => request.post('/apis/api/product/product_list', data);  //产品列表

export const productInfo = (data) => request.post('/apis/api/product/product_detail', data);  //产品详情

export const productCount = (data) => request.post('/apis/api/product/product_tongji', data);  //产品统计

export const productSearch = (data) => request.post('/apis/api/product/product_search', data);  //产品搜索

export const resourcesList = (data) => request.post('/apis/api/article/index', data);  //新闻列表

export const resourcesInfo = (data) => request.post('/apis/api/article/detail', data);  //新闻详情

export const careersCate = (data) => request.post('/apis/api/index/careers_cate', data);  //查询岗位左侧分类

export const careersLocation = (data) => request.post('/apis/api/index/careers_address', data);  //查询岗位左侧地点

export const careersList = (data) => request.post('/apis/api/careers/careers_list', data);  //查询岗位列表

export const eventsList = (data) => request.post('/apis/api/events/index', data);  //查询展会列表

export const formSubmit = (data) => request.post('/apis/api/message/index', data);  //留言

export const formProductSubmit = (data) => request.post('/apis/api/message/product_message', data);  //产品留言

export const careersFormSubmit = (data) => request.post('/apis/api/message/careers_message', data);  //岗位留言

export const uploadFiles = (data) => request.post('/apis/api/index/uploads', data);  //上传附件

export const searchList = (data) => request.post('/apis/api/index/search', data);  //全局搜索

export const productTest = (data) => request.post('/apis/api/index/product_test', data);  //产品检测类型

export const clutureList = (data) => request.post('/apis/api/index/culture', data);  //企业文化